/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Layout_Header_Whats_NewInputs */



/**
* | output |
* | --- |
* | "What's new" |
*
* @param {Layout_Header_Whats_NewInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
export const layout_header_whats_new = /** @type {((inputs?: Layout_Header_Whats_NewInputs, options?: { locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Layout_Header_Whats_NewInputs, { locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Neuigkeiten")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Nouveautés")
	if (locale === "zh-Hans") return /** @type {LocalizedString} */ ("更新内容")
	if (locale === "zh-Hant") return /** @type {LocalizedString} */ ("最新消息")
	if (locale === "ko") return /** @type {LocalizedString} */ ("새로운 소식")
	return /** @type {LocalizedString} */ ("What's new")
});